"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFromLocalStorage = void 0;
const constants_1 = require("utils/constants");
exports.getFromLocalStorage = {
    token: () => {
        const token = localStorage.getItem(constants_1.localStorageKey.token);
        if (token)
            return token;
        return '';
    }
};
